export const animationSettings = {
  states: {
    beautyPerfumeBirkholz: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-perfume',
      showEls: ['perfume-birkholz'],
    },
    beautyTeeth: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-teeth',
      showEls: ['teeth'],
    },
    beautyCream: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-cream',
      showEls: ['cream'],
    },
    beautyCreamFluid: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-cream-fluid',
      showEls: ['cream-fluid'],
    },
    beautyPerfume: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-perfume',
      showEls: ['perfume'],
    },
    beautySerumFace: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-serum-face',
      showEls: ['serum-face'],
    },
    beautyPatches: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-patches',
      showEls: ['patches_1'],
    },
    beautyMask: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-mask',
      showEls: ['mask'],
    },
    beautyFoam: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-foam',
      showEls: ['foam_1', 'foam'],
    },
    beautyCreamEyes: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-cream-eyes',
      showEls: ['cream-eyes'],
    },
    beforeBeauty: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-done',
      showEls: ['beauty-done'],
    },
    beforePurchase: {
      loop: false,
      clampWhenFinished: true,
      animation: 'beauty-done',
      showEls: ['beauty-done'],
    },
    done: {
      loop: false,
      clampWhenFinished: true,
      animation: 'done',
    },
    interior: {
      loop: false,
      clampWhenFinished: true,
      animation: 'interior',
    },
    outerwear: {
      loop: false,
      clampWhenFinished: true,
      animation: 'outerwear',
    },
    wink: {
      loop: false,
      clampWhenFinished: true,
      animation: 'idle-02',
    },
    idle: {
      loop: true,
      clampWhenFinished: true,
      animation: 'idle-01',
    },
    life: {
      loop: false,
      animation: 'idle-03',
      clampWhenFinished: true,
    },
    happy: {
      loop: false,
      clampWhenFinished: true,
      animation: 'idle-04',
    },
    sad: {
      loop: false,
      clampWhenFinished: true,
      animation: 'sad',
    },
    hello: {
      loop: false,
      clampWhenFinished: true,
      animation: 'hello',
    },
    interaction: {
      loop: false,
      clampWhenFinished: true,
      animation: 'interaction-01',
    },
    happyInteraction: {
      loop: false,
      clampWhenFinished: true,
      animation: 'interaction-02',
    },
  },
};

export const getClipByAnimation = (name) =>
  Object.entries(animationSettings.states).find(([, { animation }]) => {
    return animation === name;
  })[0];

const animationControlObject = {
  beautyCream: (duration) => ({
    inSettings: {
      in: duration * 0.5,
      ease: 'power1.in',
    },
    outSettings: {
      out: duration * 0.5,
      ease: 'power1.in',
    },
  }),
  beautyMask: (duration) => ({
    inSettings: {
      in: duration / 3,
      ease: 'power2.in',
    },
    middleSettings: {
      middle: duration / 3,
      ease: 'none',
    },
    outSettings: {
      out: duration / 3,
      ease: 'power2.in',
    },
  }),
};

export const animationControl = ({ name, duration }) => {
  const currentClip = getClipByAnimation(name);
  return animationControlObject[currentClip](duration);
};

export const elfSnapshotSize = {
  height: 500,
};
